import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AdminService } from 'src/app/services/admin.service';
import { ConfigService } from 'src/app/services/config.service';
import { DataService } from 'src/app/services/data.service';
import { HomeService } from 'src/app/services/home.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  // OpenConsent: boolean = true
  libWebsite: string = '';
  Telephone: string;
  EmailContact: string;
  address: string;
  facebook: string;
  AboutUsFooter: string;
  backgroundFooter: string = 'var(--wl-bg-color-footer)';
  colorFooter: string = 'var(--wl-color-footer)';
  logoSubcription: Subscription = new Subscription();
  pdpaUrl: '';
  version: string = '';
  lang: string = 'en';

  
  constructor(
    private homeService: HomeService,
    private adminService: AdminService,
    private data: DataService,
    private translate: TranslateService,
    private configService: ConfigService
  ) {

    this.version = this.configService.getVersion;

    this.lang = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';
    this.translate.setDefaultLang(this.lang);


    this.AboutUsFooter = '';
    this.homeService.getParameter('AboutUsFooter').subscribe((VALUE: any) => {
      if (VALUE.length == 1) {
        this.AboutUsFooter = VALUE[0].VALUE;
      }
    });


    this.Telephone = '';
    this.homeService.getParameter('TelNo').subscribe((VALUE: any) => {
      if (VALUE.length == 1) {
        this.Telephone = VALUE[0].VALUE;
      }
    });

    this.EmailContact = '';
    this.homeService.getParameter('EmailContact').subscribe((VALUE: any) => {
      if (VALUE.length == 1) {
        this.EmailContact = VALUE[0].VALUE;
      }
    });

    this.address = '';
    if (this.lang === 'TH') {
      this.homeService.getParameter('addressTH').subscribe((VALUE: any) => {
        if (VALUE.length == 1) {
          this.address = VALUE[0].VALUE;
        }
      });
    } else {
      this.homeService.getParameter('addressEN').subscribe((VALUE: any) => {
        if (VALUE.length == 1) {
          this.address = VALUE[0].VALUE;
        }
      });
    }
    

    this.facebook = '';
    this.homeService.getParameter('LibraryFacebookURL').subscribe((VALUE: any) => {
      if (VALUE.length == 1) {
        this.facebook = VALUE[0].VALUE;
      }
    });

    this.getcolor();

    this.homeService.getParameter('PDPAUrl').subscribe((VALUE: any) => {
      if (VALUE.length == 1) {
        this.pdpaUrl = VALUE[0].VALUE;
      }
    });


    this.homeService.getParameter('LibrarySiteURL').subscribe((VALUE: any) => {
      if (VALUE.length == 1) {
        this.libWebsite = VALUE[0].VALUE;
      }
    })


  }

  ngOnDestroy(): void {
    if (this.logoSubcription) {
      this.logoSubcription.unsubscribe();
    }
  }

  getcolor() {  
    
    this.data.currentcolorBGFooter.subscribe(
      (backgroundFooter) => (this.backgroundFooter = backgroundFooter)
    );

    this.data.currentcolorFooter.subscribe(
      (colorFooter) => (this.colorFooter = colorFooter)
    );

    // this.adminService
    //   .getColorSetting('FooterColor')
    //   .subscribe((val: string) => {
    //     if (val != '') {
    //       this.colorFooter = val;
    //     }
    //   });


    this.logoSubcription =  this.adminService.getColorSettingPipe('FooterColor')
    .pipe(
      switchMap(async (res: any) => {
       
        switch (res.status) {
          case 200:
            this.colorFooter =res.body
            break;
          default:
        }
      }),
      catchError((e) => {
        return of([]);
      })
    )
    .subscribe();

    this.logoSubcription =  this.adminService.getColorSettingPipe('FooterBg')
    .pipe(
      switchMap(async (res: any) => {
       
        switch (res.status) {
          case 200:
            this.backgroundFooter =res.body
            break;
          default:
        }
      }),
      catchError((e) => {
        return of([]);
      })
    )
    .subscribe();

    // this.adminService.getColorSetting('FooterBg').subscribe((val: string) => {
    //   if (val != '') {
    //     this.backgroundFooter = val;
    //   }
    // });
 
  }


  // acceptPDPA(){
  //   this.OpenConsent = false
  //   localStorage.setItem('OpenConsent', 'true')
  // }
}
